import { PronosticoLocalMapasApi } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { client as fetch } from './ClientService'

export interface PronosticoLocalMapasInterface {
  getPronosticoLocalMapas():Promise<Commit<PronosticoLocalMapasApi>>
}

export default class PronosticoLocalMapasService implements PronosticoLocalMapasInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin

  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }

  async getPronosticoLocalMapas (): Promise<Commit<PronosticoLocalMapasApi>> {
    try {
      const response = await fetch(`${this.apiUrl}/api/pronostico/imagenes/pronostico-local`)
      return { type: 'PRONOSTICO_LOCAL_FETCHED', payload: response }
    } catch (e) {
      return { type: 'PRONOSTICO_LOCAL_ERROR', payload: e }
    }
  }
}
